// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".inValida[data-v-21ae7c7a] {\n  border: 1px solid #a94442;\n}\n.mensagemDeErro[data-v-21ae7c7a] {\n  margin: 0 0 10px 0;\n  color: #a94442;\n  font-size: 12px;\n}\n.labelObrigatorio[data-v-21ae7c7a] {\n  color: #a94442;\n}", ""]);
// Exports
module.exports = exports;
